import React from 'react';
import { addCommas } from '../../../rewardsAndRecognitionHelper/utils.js';

const ApprovalRewards = (props) => {
	const { approvalCountData } = props;

	const SummaryStatBox = ({ color, label, total }) => (
		<div className="color-card" style={{ width: '33.33333%', background: color }}>
			<h4>{addCommas(total)}</h4>
			<p>{label}</p>
		</div>
	);

	// Default values if data is not available
	const pending = approvalCountData?.pending || 0;
	const approved = approvalCountData?.approved || 0;
	const declined = approvalCountData?.declined || 0;
	const total = approvalCountData?.total || 0;

	const pendingBonus = approvalCountData?.pendingBonus || 0;
	const approvedBonus = approvalCountData?.approvedBonus || 0;
	const declinedBonus = approvalCountData?.declinedBonus || 0;

	return (
		<div className="contact-card-wrap">
			<div className="contact-card">
				<div className="contact-card-inner">
					<div className="contact-card-title">Recognition Approval Status</div>
					<div className="contact-color-card">
						<SummaryStatBox
							color="rgb(20, 214, 211)"
							label="Pending"
							total={pending}
						/>
						<SummaryStatBox
							color="rgb(231, 93, 167)"
							label="Approved"
							total={approved}
						/>
						<SummaryStatBox
							color="rgb(130, 106, 230)"
							label="Declined"
							total={declined}
						/>
					</div>
				</div>
			</div>
			<div className="contact-card">
				<div className="contact-card-inner">
					<div className="contact-card-title">Total Recognitions</div>
					<div className="contact-color-card">
						<SummaryStatBox
							color="rgb(20, 214, 211)"
							label="Total"
							total={total}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ApprovalRewards;
